<template>
  <PrismEditor
    v-bind="$attrs"
    v-model="model"
    class="code-editor"
    :highlight="highlighter"
    :line-numbers="true"
  />
</template>

<script lang="ts" setup>
import { PrismEditor } from 'vue-prism-editor'
import 'vue-prism-editor/dist/prismeditor.min.css'
import { highlight, languages } from 'prismjs/components/prism-core'
import 'prismjs/components/prism-clike'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-markup'
import 'prismjs/themes/prism-tomorrow.css'

const model = defineModel<string>()

const props = defineProps({
  lang: {
    type: String,
    default: 'js',
  },
})

const highlighter = (code) => {
  return highlight(code, languages[props.lang], props.lang)
}
</script>

<style lang="scss">
/* required class */
.code-editor {
  background: #dee2f3;
  color: #212529;

  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
  max-height: 400px;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
}
</style>
